import { setAuthLoginStart, setAuthLoginSuccess, setAuthLoginFailure, setAuthLogout, restoreSession, setPermissions } from "../reducers/auth";
import { login as lewooLogin, me as lewooMe, logout as lewooLogout, getStoredUser, getStoredPermissions } from "../../services/lewooAuth";
import { getToken } from "../../services/lewooApi";

// Fallback conservateur : si le back ne renvoie pas de permissions, accès refusé
// sauf pour un admin « spécial » (compat legacy). Les droits modules sont tous à false.
const conservativePermissions = (user) => {
  const isSettingsAdmin = !!(user?.is_special || user?.is_settings_admin);
  return {
    isSettingsAdmin,
    isSpecial: isSettingsAdmin,
    isAdmin: !!user?.is_admin || user?.role === "admin",
  };
};

const resolvePermissions = (permissions, user) => {
  if (permissions && typeof permissions === "object" && "isAdmin" in permissions) {
    return permissions;
  }
  return conservativePermissions(user);
};

export const loginUser = (login, password) => async (dispatch) => {
  dispatch(setAuthLoginStart());
  try {
    const { token, user, permissions } = await lewooLogin(login, password);

    dispatch(setAuthLoginSuccess(user, token));

    dispatch(setPermissions(resolvePermissions(permissions, user)));

    return { ok: true, user };
  } catch (err) {
    const message = err.message || "Échec de l'authentification";
    dispatch(setAuthLoginFailure(message));
    return { ok: false, error: message };
  }
};

export const logout = () => async (dispatch) => {
  lewooLogout();
  dispatch(setAuthLogout());
};

export const restoreAuthSession = () => async (dispatch) => {
  const token = getToken();
  const storedPermissions = getStoredPermissions();

  if (!token) {
    const storedUser = getStoredUser();
    if (storedUser) {
      dispatch(restoreSession(storedUser, null));
      dispatch(setPermissions(resolvePermissions(storedPermissions, storedUser)));
    } else {
      dispatch(setAuthLogout());
    }
    return;
  }

  try {
    const session = await lewooMe();
    if (session?.user) {
      dispatch(restoreSession(session.user, token));
      dispatch(setPermissions(resolvePermissions(session.permissions, session.user)));
      return;
    }
  } catch (_) {}

  const storedUser = getStoredUser();
  if (storedUser) {
    dispatch(restoreSession(storedUser, token));
    dispatch(setPermissions(resolvePermissions(storedPermissions, storedUser)));
    return;
  }

  dispatch(setAuthLogout());
};
